import { ImageOutlined } from '@mui/icons-material';
import { Box, Card, CardActionArea, CardContent, CardMedia, Chip, Stack, Typography } from '@mui/material';

const formatPrice = (price) => {
  if (typeof price !== 'number') return null;
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 0,
  }).format(price);
};

const ProductCard = ({ product, onClick }) => {
  const image = product.images[0];
  const colors = [...new Set(product.variants.map((variant) => variant.color).filter(Boolean))];
  const sizes = [...new Set(product.variants.flatMap((variant) => variant.sizes).filter(Boolean))];
  const price = formatPrice(product.price);

  return (
    <Card elevation={0} sx={{ border: '1px solid #eadfdb', borderRadius: 2, overflow: 'hidden', bgcolor: '#fffdfb' }}>
      <CardActionArea onClick={() => onClick(product)} sx={{ height: '100%', alignItems: 'stretch' }}>
        {image ? (
          <CardMedia component="img" image={image} alt={product.name} sx={{ height: 178, objectFit: 'cover', bgcolor: '#f5eeea' }} />
        ) : (
          <Box sx={{ height: 178, display: 'grid', placeItems: 'center', bgcolor: '#f5eeea', color: '#9a7d73' }}>
            <ImageOutlined sx={{ fontSize: 38 }} />
          </Box>
        )}
        <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
          {product.category && <Typography variant="caption" color="text.secondary">{product.category}</Typography>}
          <Typography variant="subtitle2" sx={{ mt: 0.25, fontWeight: 700, lineHeight: 1.3 }} noWrap>{product.name}</Typography>
          {price && <Typography sx={{ mt: 0.7, color: '#a52a4b', fontWeight: 800 }}>{price}</Typography>}
          {(colors.length > 0 || sizes.length > 0) && (
            <Stack spacing={0.6} sx={{ mt: 1.1 }}>
              {colors.length > 0 && <Typography variant="caption" color="text.secondary" noWrap>Colores: {colors.join(' · ')}</Typography>}
              {sizes.length > 0 && <Typography variant="caption" color="text.secondary" noWrap>Talles: {sizes.join(' · ')}</Typography>}
            </Stack>
          )}
          <Chip label="Ver detalle" size="small" sx={{ mt: 1.1, color: '#8d2443', bgcolor: '#fbe9ee', fontWeight: 700 }} />
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ProductCard;